import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { resendVerifyEmail } from 'actions/User';
import { clearModal } from 'actions';
import { RESEND_VERIFIY_EMAIL } from 'constants/ModalTypes';

const StyledModalHeader = styled(ModalHeader)`
  padding: 24px;
  text-align: center;
  h5 {
    font-weight: 700;
  }
`;

const Paragraph = styled.p`
  text-align: center;

  svg {
    width: 30px;
    height: 30px;
  }
`;

const VerifyEmailModal = ({ isOpen, email, resendVerifyEmail, clearModal }) => {
  const handleResend = useCallback(() => {
    resendVerifyEmail();
    clearModal();
  }, []);

  return (
    <Modal isOpen={isOpen} toggle={clearModal}>
      <StyledModalHeader>Please Verify Your Email</StyledModalHeader>
      <ModalBody>
        <Paragraph>
          <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
        </Paragraph>
        <Paragraph>You're almost there! We sent an email to:</Paragraph>
        <Paragraph>
          <strong>{email}</strong>
        </Paragraph>
        <Paragraph>
          Just click on the link in that email to complete your signup. If you
          don't see it, <strong>check your spam</strong> folder
        </Paragraph>
        <Paragraph>
          Still can't find the email? Click resend button below
        </Paragraph>
        <Paragraph>
          <Button onClick={handleResend} color="primary">
            Resend Verification Email
          </Button>
        </Paragraph>
      </ModalBody>
    </Modal>
  );
};

VerifyEmailModal.propTypes = {
  isOpen: PropTypes.bool,
  resendVerifyEmail: PropTypes.func,
  email: PropTypes.string,
};

export default connect(
  ({ modal, user }) => ({
    isOpen: modal && modal.type === RESEND_VERIFIY_EMAIL,
    email: user && user.email,
  }),
  (dispatch) => ({
    clearModal: () => dispatch(clearModal(RESEND_VERIFIY_EMAIL)),
    resendVerifyEmail: () => dispatch(resendVerifyEmail()),
  }),
)(VerifyEmailModal);
